// Shared constants (images, categories, status labels, formatters). Data now comes from the backend API.

export const IMAGES = {
  chicken: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  burger: 'https://images.pexels.com/photos/4571510/pexels-photo-4571510.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  pizza: 'https://images.unsplash.com/photo-1593504049359-74330189a345?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  tacos: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  sushi: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  wings: 'https://images.unsplash.com/photo-1567620832903-9fc6debc209f?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  coffee: 'https://images.unsplash.com/photo-1502462041640-b3d7e50d0662?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  cola: 'https://images.unsplash.com/photo-1648569883125-d01072540b4c?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  soda: 'https://images.pexels.com/photos/4113617/pexels-photo-4113617.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  juice: 'https://images.unsplash.com/photo-1613478223719-2ab802602423?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  pharmacy: 'https://images.pexels.com/photos/3873150/pexels-photo-3873150.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  supermarket: 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  rider: 'https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  rider2: 'https://images.unsplash.com/photo-1572195577046-2f25894c06fc?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  combo: 'https://images.pexels.com/photos/33254639/pexels-photo-33254639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  combo2: 'https://images.pexels.com/photos/27497770/pexels-photo-27497770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

export const avatar = (n) => `https://i.pravatar.cc/120?img=${n}`;

export const CATEGORIES = [
  { id: 'comida', name: 'Restaurantes', color: '#FDECEC', icon: 'Utensils', iconColor: '#EE3B36' },
  { id: 'cafeteria', name: 'Cafeterías', color: '#F3E9DD', icon: 'Coffee', iconColor: '#8B5E34' },
  { id: 'tienda', name: 'Tiendas', color: '#E3F0FF', icon: 'Store', iconColor: '#2F80ED' },
  { id: 'mandaditos', name: 'Mandaditos 7', color: '#FDECEC', icon: 'ShoppingBag', iconColor: '#EE3B36' },
  { id: 'regalos', name: 'Flores y Regalos', color: '#FDECF3', icon: 'Gift', iconColor: '#D6336C' },
  { id: 'farmacia', name: 'Farmacia', color: '#E6F7F1', icon: 'Pill', iconColor: '#22A45D' },
  { id: 'supermercado', name: 'Supermercado', color: '#F1ECFD', icon: 'ShoppingCart', iconColor: '#7C3AED' },
];

// Tipos de negocio para filtros del cliente
export const BUSINESS_TYPES = [
  { v: 'all', l: 'Todos' },
  { v: 'comida', l: 'Restaurantes' },
  { v: 'cafeteria', l: 'Cafeterías' },
  { v: 'tienda', l: 'Tiendas' },
  { v: 'regalos', l: 'Flores y Regalos' },
  { v: 'farmacia', l: 'Farmacia' },
  { v: 'supermercado', l: 'Supermercado' },
];

// Ocasiones para la sección de Flores y Regalos
export const OCASIONES = [
  { id: 'cumpleanos', label: 'Cumpleaños' },
  { id: 'aniversario', label: 'Aniversario' },
  { id: 'amor', label: 'Amor' },
  { id: 'condolencias', label: 'Condolencias' },
  { id: 'bebe', label: 'Nuevo bebé' },
  { id: 'graduacion', label: 'Graduación' },
  { id: 'porque-si', label: 'Solo porque sí' },
];

// Contacto / Centro de llamadas (Honduras +504)
export const CONTACT = {
  callCenter: ['9871-3839', '8947-2544', '9946-9876'],
  whatsapp: '9871-3839', // número principal
  email: 'soporte@delibery7.com',
};
export const APP_VERSION = '2.0';
// WhatsApp channel inside the customer app (floating button, support screen,
// password recovery). Flip to true to show it again.
export const SHOW_WHATSAPP = true;
export const WA_INCIDENT_MSG = 'Hola 👋 Quiero reportar un incidente con mi pedido en Delibery 7.';
const internationalPhone = (number) => {
  const digits = String(number || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('00')) return digits.slice(2);
  return digits.length === 8 ? `504${digits}` : digits;
};
export const telHref = (n) => internationalPhone(n) ? `tel:+${internationalPhone(n)}` : undefined;
export const waHref = (n, text) => `https://wa.me/504${(n || '').replace(/[^0-9]/g, '')}${text ? `?text=${encodeURIComponent(text)}` : ''}`;

// Unified order statuses (see contracts.md)
export const ORDER_STATUS = {
  awaiting_payment: { label: 'Verificando pago', color: 'bg-orange-100 text-orange-700' },
  awaiting_driver: { label: 'Confirmación del conductor', color: 'bg-cyan-100 text-cyan-800' },
  awaiting_business: { label: 'Verificación del negocio', color: 'bg-amber-100 text-amber-800' },
  pending: { label: 'Pendiente', color: 'bg-gray-100 text-gray-700' },
  preparing: { label: 'En preparación', color: 'bg-amber-100 text-amber-700' },
  ready: { label: 'Listo para recoger', color: 'bg-sky-100 text-sky-700' },
  on_way: { label: 'En camino', color: 'bg-blue-100 text-blue-700' },
  completed: { label: 'Completado', color: 'bg-emerald-100 text-emerald-700' },
  cancelled: { label: 'Cancelado', color: 'bg-red-100 text-red-600' },
};

// Etiquetas propias del flujo "Recoger en tienda"
export const PICKUP_STATUS = {
  awaiting_payment: 'Verificando pago',
  awaiting_business: 'Verificación del negocio',
  pending: 'Pedido recibido',
  preparing: 'En preparación',
  ready: 'Listo para recoger',
  completed: 'Recogido',
  cancelled: 'Cancelado',
};
export const isPickup = (o) => o?.orderMode === 'pickup';
export const statusLabel = (o) => (isPickup(o) ? PICKUP_STATUS[o.status] : ORDER_STATUS[o?.status]?.label) || o?.status;

// Servicios habilitados por el administrador para cada negocio
export const serviceLabel = (r) => (r?.delivery && r?.pickup ? 'Domicilio + Recoger en tienda' : r?.pickup ? 'Solo recoger en tienda' : 'Solo domicilio');

export const ACTIVE_STATUSES = ['awaiting_payment', 'awaiting_driver', 'awaiting_business', 'pending', 'preparing', 'ready', 'on_way'];

export const money = (n) => `L ${Number(n || 0).toLocaleString('es-HN')}`;
